<template>
  <v-dialog
    v-model="show"
    fullscreen
    hide-overlay
    :transition="false"
  >
    <v-card>
      <v-card-title>
        <v-layout justify-space-between>
          <v-flex shrink>
            <p class="mb-0 pt-2 f-2">
              {{ $t('description.example_desc') }}
            </p>
          </v-flex>
          <v-flex shrink>
            <v-icon
              large
              class="clickable"
              @click.prevent="close"
            >
              clear
            </v-icon>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-layout
        justify-center
        mt-3
      >
        <v-flex
          xs12
          sm8
          :mx-3="xsOnly"
        >
          <previewDescription
            v-for="(item, index) in descriptionExamples.EXAMPLES"
            :key="index"
            :important-needs="item.needs"
            :family-guide="null"
            :custom-family-list="item.family"
            :custom-title="customTitle(index, item.familyType)"
            :custom-history="item.history"
            :custom-beauty="item.beauty"
            :custom-everyday-life="item?.everydayLife"
          />
        </v-flex>
      </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>
import PreviewDescription from '@/components/description/previewDescription';

import descriptionExamples from '@/constants/descriptionExamples';

export default {
    name: 'DescripionExamplesDialog',
    components: { PreviewDescription },
    props: {
        value: Boolean
    },
    data () {
        return {
            descriptionExamples
        };
    },
    computed: {
        show: {
            get () {
                return this.value;
            },
            set (value) {
                this.$emit('input', value);
            }
        },
        xsOnly () {
            return this.$vuetify.breakpoint.xsOnly;
        }
    },
    methods: {
        close () {
            this.show = false;
        },
        customTitle (index, type) {
            return `Przykład ${index + 1}: ${type}`;
        }
    }
};
</script>

<style scoped></style>
